const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "home":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "home",
    reducer: reducer,
};

export default data;
